/**
 * @param {UserService} userService
 */
const nameWithTitleDirective = function (userService) {
    return {
        restrict: 'E',
        scope: {
            contact: '=',
        },
        template: function template() {
            // We want to show "title firstName lastName", but suppress the title if the company
            // does not have them enabled.
            let titleTemplate = userService.company.shouldCaptureTitles() ? '{{ contact.title }} ' : '';

            return titleTemplate + '{{ contact.firstName }} {{ contact.lastName }}';
        },
    };
};

module.exports = nameWithTitleDirective;
